export const WRAPPER_CLASS = 'tiptap-textblock-wrapper';
export const SELECTION_CHECK_DELAY = 10;

export const getWrapperElement = (node: Node): Element | null => {
  let current: Node | null = node;
  while (current && current !== document.body) {
    if (current.nodeType === Node.ELEMENT_NODE) {
      const element = current as Element;
      if (element.classList.contains(WRAPPER_CLASS)) {
        return element;
      }
    }
    current = current.parentNode;
  }
  return null;
};

export const isSelectionWithinSingleBlock = (selection: Selection): boolean => {
  if (!selection || selection.rangeCount === 0 || selection.isCollapsed) {
    return true;
  }

  const range = selection.getRangeAt(0);
  const startWrapper = getWrapperElement(range.startContainer);
  const endWrapper = getWrapperElement(range.endContainer);

  if (!startWrapper || !endWrapper) {
    return false;
  }

  return startWrapper === endWrapper;
};
